module.exports = __webpack_public_path__ + "img/7.8c4f9ef1.png";